import { Rocket, Flame, BarChart3, Trophy } from "lucide-react";

const PHASES = [
  {
    id: 1,
    icon: Rocket,
    label: "PHASE 01",
    title: "FAIR LAUNCH ON PUMP.FUN",
    points: [
      "Fair launch on pump.fun",
      "Open bonding curve (every soldier on the same line)",
      "LA28 Army community formed across X & Telegram",
    ],
    accent: "#00F0FF",
  },
  {
    id: 2,
    icon: Flame,
    label: "PHASE 02",
    title: "VIRAL IGNITION",
    points: [
      "Meme contests & creator bounties",
      "Influencer amplification & cultural raids",
      "Trend-jacking the countdown narrative",
    ],
    accent: "#FFD700",
  },
  {
    id: 3,
    icon: BarChart3,
    label: "PHASE 03",
    title: "RAYDIUM MIGRATION & LIQUIDITY",
    points: [
      "Bonding curve completion → auto-migrate to Raydium",
      "DEX volume scaling & DexScreener trending",
      "Cross-chain liquidity expansion",
    ],
    accent: "#9B5CFF",
  },
  {
    id: 4,
    icon: Trophy,
    label: "PHASE 04",
    title: "THE 2028 ERA",
    points: [
      "Sustained cultural countdown campaigns",
      "IRL meet-ups, drops & army merch",
      "Long-term brand identity into 2028",
    ],
    accent: "#FF4D8D",
  },
];

export default function Roadmap() {
  return (
    <section
      id="roadmap"
      data-testid="roadmap-section"
      className="relative py-28 sm:py-36 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-cyber-grid opacity-20 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <div className="font-mono text-xs tracking-[0.32em] text-[#00F0FF] mb-5">
            // 03 · ROADMAP
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1] text-white">
            The march <br />
            <span className="text-[#FFD700] glow-gold">to 2028.</span>
          </h2>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden md:block absolute left-[26px] top-2 bottom-2 w-px dotted-line" />

          <div className="space-y-10">
            {PHASES.map((p) => (
              <div
                key={p.id}
                data-testid={`roadmap-phase-${p.id}`}
                className="relative md:pl-20"
              >
                {/* Node */}
                <div
                  className="hidden md:flex absolute left-0 top-2 w-[52px] h-[52px] items-center justify-center border-2 bg-[#0B0B12] z-10"
                  style={{
                    borderColor: p.accent,
                    boxShadow: `0 0 18px ${p.accent}66`,
                  }}
                >
                  <p.icon className="w-5 h-5" style={{ color: p.accent }} />
                </div>

                <div className="card-neon p-7 sm:p-8">
                  <div className="flex items-center gap-3">
                    <p.icon
                      className="md:hidden w-5 h-5"
                      style={{ color: p.accent }}
                    />
                    <div
                      className="font-mono text-[11px] tracking-[0.32em]"
                      style={{ color: p.accent }}
                    >
                      {p.label}
                    </div>
                  </div>
                  <h3 className="mt-2 font-heading text-2xl sm:text-3xl font-black tracking-tight text-white">
                    {p.title}
                  </h3>
                  <ul className="mt-5 space-y-2.5">
                    {p.points.map((pt) => (
                      <li
                        key={pt}
                        className="flex items-start gap-3 text-white/70"
                      >
                        <span
                          className="mt-2 w-1.5 h-1.5 shrink-0"
                          style={{ background: p.accent }}
                        />
                        <span>{pt}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
